import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconLocationAlertProps } from './IconLocationAlert.types'
import * as Styled from './styles/IconLocationAlert.style'

import { nonThemeableRules } from '../../ruleSet'

const IconLocationAlert: FC<IconLocationAlertProps> = ({
  size = nonThemeableRules.defaultSize as number as IconLocationAlertProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconLocationAlertProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='M12.375 11.941a2.975 2.975 0 1 1-.59-2.617' vectorEffect='non-scaling-stroke' />
          <path
            d='M15.793 12.04c-.7 4.105-6.309 8.937-6.309 8.937S3.11 15.453 3.11 11.203a6.377 6.377 0 0 1 6.375-6.375'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M9.457 4.828c1.469-.004 2.89.5 4.031 1.422m1.594-2.582-3.477 6.437a1.24 1.24 0 0 0 1.09 1.836h6.953c.438 0 .844-.23 1.067-.609.223-.375.23-.84.023-1.227l-3.476-6.437a1.243 1.243 0 0 0-2.18 0Zm1.09 1.82V8.43'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M16.234 10.203a.062.062 0 0 1-.062.063.062.062 0 0 1-.063-.063c0-.031.028-.062.063-.062s.062.03.062.062Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M16.48 10.203a.31.31 0 0 1-.308.313.313.313 0 0 1-.309-.313.31.31 0 0 1 .617 0Zm0 0' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconLocationAlert
